import { api } from "@/lib/api-client";

export interface ConnectionDto {
  id: string;
  name: string;
  type: string;
  config: Record<string, unknown>;
  hasPassword: boolean;
  hasClientSecret: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// ── Discriminated union for create ────────────────────────────────────────────

export interface CreatePostgresInput {
  name: string;
  type: "postgres";
  config: {
    host: string;
    port: number;
    database: string;
    user: string;
    ssl?: boolean;
    schema?: string;
  };
  password: string;
}

export interface CreateSharepointInput {
  name: string;
  type: "sharepoint";
  config: {
    azureTenantId: string;
    clientId: string;
    siteHostname: string;
    sitePath: string;
  };
  clientSecret: string;
}

export type CreateConnectionInput = CreatePostgresInput | CreateSharepointInput;

// ── Discriminated union for update ────────────────────────────────────────────

export interface UpdatePostgresInput {
  name: string;
  config: {
    host: string;
    port: number;
    database: string;
    user: string;
    ssl?: boolean;
    schema?: string;
  };
  password?: string;
}

export interface UpdateSharepointInput {
  name: string;
  config: {
    azureTenantId: string;
    clientId: string;
    siteHostname: string;
    sitePath: string;
  };
  clientSecret?: string;
}

export type UpdateConnectionInput = UpdatePostgresInput | UpdateSharepointInput;

// ── API functions ─────────────────────────────────────────────────────────────

export function listConnections(type?: string): Promise<ConnectionDto[]> {
  const qs = type ? `?type=${encodeURIComponent(type)}` : "";
  return api.get<ConnectionDto[]>(`/connections${qs}`);
}

export function createConnection(body: CreateConnectionInput): Promise<ConnectionDto> {
  return api.post<ConnectionDto>("/connections", body);
}

export function updateConnection(id: string, body: UpdateConnectionInput): Promise<ConnectionDto> {
  return api.put<ConnectionDto>(`/connections/${id}`, body);
}

export function deleteConnection(id: string): Promise<void> {
  return api.delete<void>(`/connections/${id}`);
}

export function testConnection(id: string): Promise<{ ok: boolean; error?: string }> {
  return api.post<{ ok: boolean; error?: string }>(`/connections/${id}/test`, {});
}
